export default __webpack_public_path__ + "static/media/home1.1276c150.png";